import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { ErrorPageModule } from './error-page';
import { eventsAndMeetingsSettingsUrls, integrationsUrl } from './meeting-integrations/providers';

const routes: Routes = [
  { path: 'error', loadComponent: () => import('./error-page/error-page.component').then((m) => m.ErrorPageComponent) },
  {
    path: 'public',
    loadChildren: () => import('./public-app.module').then((m) => m.PublicAppModule),
  },
  {
    // slice(1) -> removing leading /
    path: integrationsUrl.slice(1),
    pathMatch: 'full',
    loadComponent: () =>
      import('./meeting-scheduler/connection-redirect.component').then((m) => m.ConnectionRedirectComponent),
  },
  {
    // slice(1) -> removing leading /
    path: eventsAndMeetingsSettingsUrls.slice(1),
    pathMatch: 'full',
    loadComponent: () =>
      import('./meeting-scheduler/connection-redirect.component').then((m) => m.ConnectionRedirectComponent),
  },
  {
    path: 'landing',
    loadComponent: () => import('./auth/landing.component'),
  },
  {
    path: 'oauth/redirect',
    loadComponent: () => import('./auth/redirect.component'),
  },
  {
    path: 'oauth/logout',
    loadComponent: () => import('./auth/logout-redirect.component'),
  },
  {
    path: '',
    loadChildren: () => import('./authenticated-app.module').then((m) => m.AuthenticatedAppModule),
    canActivate: [AuthGuard],
  },
];
@NgModule({
  imports: [
    ErrorPageModule,
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 64],
      bindToComponentInputs: true,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
